import { gql, useMutation } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import { EnrollDependentsPayload } from "@oysterhr/schema"
import { DEPENDENTS_ON_ENROLLMENT_FRAGMENT } from "../../fragments/DependentsOnEnrollmentFragment"

export const ENROLL_DEPENDENT_MUTATION = gql`
  ${DEPENDENTS_ON_ENROLLMENT_FRAGMENT}
  mutation EnrollDependents($enrollmentId: ID!, $dependentIds: [ID!]!) {
    enrollDependents(input: { enrollmentId: $enrollmentId, dependentIds: $dependentIds }) {
      errors
      enrollment {
        id
        ...DependentsOnEnrollmentFragment
      }
    }
  }
`

export const useEnrollDependents = (options?: InjectedOptions) =>
  useMutation<{ enrollDependents: EnrollDependentsPayload }>(ENROLL_DEPENDENT_MUTATION, {
    ...options,
    fetchPolicy: "no-cache",
  })
